import { supportExpensesTypes } from './types';
import moment from "moment"

const {
  HANDLE_SUPPORT_EXPENSES_INPUTS,
  GET_SUPPORT_EXPENSES,
  EDIT_PERIOD_EXPENSES,
} = supportExpensesTypes;

const initialState = {
  date: moment(new Date()).format(`YYYY-MM`),
  company: {},
  ExpensesPeriod: []
};

export const supportExpensesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case HANDLE_SUPPORT_EXPENSES_INPUTS:
      return {
        ...state,
        [payload.key]: payload.value
      };
    case GET_SUPPORT_EXPENSES:
      return { ...state, ExpensesPeriod: payload };
    case EDIT_PERIOD_EXPENSES:
      return {
        ...state,
        ExpensesPeriod: state.ExpensesPeriod.map(item => item.id === payload ? {...item, status: item?.status === "OPEN" ? "CLOSE" : "OPEN" } : item)
      };
    default:
      return state;
  }
};